import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReservationBasicInformationInputSubHeaderComponent } from './reservation-basic-information-input-sub-header.component';
import { StaticMsgModule } from '@lib/pipes';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ReservationBasicInformationInputSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule, RouterModule],
  exports: [ReservationBasicInformationInputSubHeaderComponent],
})
export class ReservationBasicInformationInputSubHeaderModule {}
